import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import AboutView from '@/views/About/AboutView.vue'
import OrganizersView from '@/views/About/OrganizersView.vue'
import ProgramCommitteeView from '@/views/About/ProgramCommitteeView.vue'
import RegistrationView from '@/views/Attend/RegistrationView.vue'
import VenueView from '@/views/Attend/VenueView.vue'
import ArtsAndPerformanceView from '@/views/Participate/ArtsAndPerformanceView.vue'
import DemoView from '@/views/Participate/DemoView.vue'
import GraduateStudentView from '@/views/Participate/GraduateStudentView.vue'
import PapersView from '@/views/Participate/PapersView.vue'
import SustainabilityView from '@/views/Program/SustainabilityRecognition.vue'
import PictorialsView from '@/views/Participate/PictorialsView.vue'
import StudioView from '@/views/Participate/StudioView.vue'
import ProgramView from '@/views/Program/ProgramView.vue'
import StudioProgramView from '@/views/Program/AcceptedStudioView.vue'
import StudentDesignCompetition from '@/views/Participate/StudentDesignCompetition.vue'
import WIPView from '@/views/Participate/WIPView.vue'
import CallForProposalView from '@/views/About/CallForProposalView.vue'
import LastingImpactAward from '@/views/About/LastingImpactAward.vue'
import StudentWorkerView from '@/views/Participate/StudentWorkerView.vue'
import AccessibilityFAQ from '@/views/Attend/accessibilityFAQ.vue'
import VisaInformationView from '@/views/Attend/VisaInformationView.vue'
import AccommodationView from '@/views/Attend/AccommodationView.vue'
import AcceptedArtView from '@/views/Program/AcceptedArtView.vue'
import AcceptedGSCView from '@/views/Program/AcceptedGSCView.vue'
import AcceptedPapersView from '@/views/Program/AcceptedPapersView.vue'
import AcceptedSDCView from '@/views/Program/AcceptedSDCView.vue'
import AcceptedStudioView from '@/views/Program/AcceptedStudioView.vue'
import AcceptedPictorialsView from '@/views/Program/AcceptedPictorialsView.vue'
import AcceptedWIPView from '@/views/Program/AcceptedWIPView.vue'
import HomeViewTEST from '@/views/HomeViewTEST.vue'
import KeynoteSpeakersView from '@/views/Program/KeynoteSpeakersView.vue'
import PresentersInstructionsView from '@/views/Participate/PresentersInstructions.vue'
import RouteToAgora from '@/views/Attend/routeToAgora.vue'
import CollectYourBadge from '@/views/Attend/CollectYourBadgeView.vue'
import PublicTransportation from '@/views/Attend/PublicTransportationView.vue'
import WelcomeToTheConferenceView from '@/views/Attend/WelcomeToTheConferenceView.vue'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeView
    }, {
      path: '/testhome',
      name: 'HomeTest',
      component: HomeViewTEST
    },
    {
      path: '/about/about',
      name: 'About',
      component: AboutView
    },
    {
      path: '/about/organizers',
      name: 'Organizers',
      component: OrganizersView
    },
    {
      path: '/about/program-committee',
      name: 'ProgramCommittee',
      component: ProgramCommitteeView
    },
    {
      path: '/call_for_proposals',
      name: 'Call for proposals',
      component: CallForProposalView
    },
    {
      path: '/about/lasting_impact_award',
      name: 'Lasting impact award',
      component: LastingImpactAward
    },
    {
      path: '/program/program',
      name: 'Program',
      component: ProgramView
    },
    {
      path: '/program/accepted_arts',
      component: AcceptedArtView
    },
    {
      path: '/program/accepted_gsc',
      component: AcceptedGSCView
    },
    {
      path: '/program/accepted_papers',
      component: AcceptedPapersView
    },
    {
      path: '/program/accepted_pictorials',
      component: AcceptedPictorialsView
    },
    {
      path: '/program/accepted_sdc',
      component: AcceptedSDCView
    },
    {
      path: '/program/accepted_studio',
      component: AcceptedStudioView
    },
    {
      path: '/program/accepted_wip',
      component: AcceptedWIPView
    },
    {
      path: '/program/sustainability',
      name: 'Sustainability Recognition',
      component: SustainabilityView
    },
    {
      path: '/program/keynote_speakers',
      name: 'Keynote Speaker',
      component: KeynoteSpeakersView
    },
    {
      path: '/participate/papers',
      name: 'Papers',
      component: PapersView
    },
    {
      path: '/participate/pictorials',
      name: 'Pictorials',
      component: PictorialsView
    },
    {
      path: '/participate/arts_and_performance',
      name: 'Arts and Performance',
      component: ArtsAndPerformanceView
    },
    {
      path: '/participate/studio',
      name: 'Studio',
      component: StudioView
    },
    {
      path: '/participate/demo_arrangement',
      name: 'Demo',
      component: DemoView
    },
    {
      path: '/participate/graduate_student_consortium',
      name: 'Graduate Student Consortium',
      component: GraduateStudentView
    },
    {
      path: '/participate/student_design_competition',
      name: 'Student Design Competition',
      component: StudentDesignCompetition
    },
    {
      path: '/participate/work_in_progress',
      name: 'Work In Progress',
      component: WIPView
    },
    {
      path: '/participate/student_volunteers',
      name: 'Student Workers',
      component: StudentWorkerView
    },
    {
      path: '/participate/presenters_instructions',
      name: 'Presenters Instructions',
      component: PresentersInstructionsView
    },
    {
      path: '/attend/registration',
      name: 'Registration',
      component: RegistrationView
    },
    {
      path: '/attend/visainformation',
      name: 'VisaInformation',
      component: VisaInformationView
    },
    {
      path: '/attend/venue',
      name: 'Venue',
      component: VenueView
    },
    {
      path: '/attend/routeToAgora',
      name: 'routeToAgora',
      component: RouteToAgora
    },
    {
      path: '/attend/accommodation',
      name: 'Accommodation',
      component: AccommodationView
    },
    {
      path: '/attend/collect-your-badge',
      name: 'Collect Your Badge',
      component: CollectYourBadge
    },
    {
      path: '/attend/welcome-to-tei25',
      name: 'Welcome to TEI25',
      component: WelcomeToTheConferenceView
    },
    {
      path: '/attend/public-transportation',
      name: 'Public Transportation',
      component: PublicTransportation
    },
    {
      path: '/attend/accessibility',
      name: 'Accessibility',
      component: AccessibilityFAQ
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
})

export default router
